import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

function logError(scope: unknown, error: unknown) {
  window.console.error("react-query", scope, error);
}

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => logError(query.queryKey, error)
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => logError(mutation.options.mutationKey ?? "mutation", error)
  }),
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      staleTime: 0
    },
    mutations: {
      retry: false
    }
  }
});

export default queryClient;
